import { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
import {
    GestureResponderEvent,
    MeasureInWindowOnSuccessCallback,
    Pressable,
    PressableProps,
    View,
} from "react-native";

type PressableWithFocusRef = {
    focus: (e: GestureResponderEvent) => void;
};

// eslint-disable-next-line react/display-name
export const PressableWithFocus = forwardRef<PressableWithFocusRef, PressableProps>(
    (props, ref) => {
        const pressableRef = useRef<View>(null);

        const focus = useCallback(
            (e: GestureResponderEvent) => {
                props.onPress?.(e);
            },
            [props],
        );

        useImperativeHandle(ref, () => ({
            measureInWindow: (callback: MeasureInWindowOnSuccessCallback) =>
                pressableRef.current?.measureInWindow?.(callback),
            focus,
        }));

        return <Pressable ref={pressableRef} {...props} />;
    },
);
